import { Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { IResumeItem } from "src/types/atoms";
const ResumeItem = ({
  label,
  value
}: IResumeItem) => {
  return <Stack direction={"row"} justifyContent={"space-between"} marginBottom={1.5}>
      <Typography color={grey[600]}>{label}</Typography>
      <Typography color={grey[600]}>{value}</Typography>
    </Stack>;
};
export default ResumeItem;